<template>
  <div class="ranking-list">
    <transition-group tag="ul" name="list">
      <li v-for="item in items" :key="item.name">
        <div class="id">{{ item.ranking }}</div>
        <div class="image">
          <webp-image :src="item.icon" :alt="item.name" width="100%" height="100%" />>
        </div>
        <div class="name">{{ item.name }}</div>
        <div class="course">{{ duration2course(item.duration) }}</div>节
      </li>
    </transition-group>
  </div>
</template>

<script>
  import WebpImage from '@/components/common/WebpImage'

  export default {
    name: 'ranking-list',
    props: {
      items: {
        type: Array,
        required: true
      }
    },
    computed: {
      basicDonateDuration () {
        return this.$store.state.BASIC_DONATE_DURATION
      }
    },
    methods: {
      duration2course (duration) {
        return Math.floor(duration / this.basicDonateDuration)
      }
    },
    components: {
      WebpImage
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/vars";

  .ranking-list {
    padding-left: 40px;
    padding-right: 40px;
    li {
      display: flex;
      padding-top: 30px;
      padding-bottom: 30px;
      font-size: 28px;
      color: $black;
      line-height: 80px;
      border-bottom: 2px solid rgba(#979797, 0.2);
      .id {
        position: absolute;
        width: 55px;
        font-size: 32px;
        font-weight: 400;
      }
      .image {
        width: 80px;
        height: 80px;
        margin-left: 65px;
        margin-right: 30px;
        font-size: 0;
        text-align: center;
        border-radius: 50%;
        overflow: hidden;
      }
      .name {
        @include text-ellipsis;
        flex: 1;
        font-size: 30px;
        color: $black;
      }
      .course {
        width: 160px;
        margin-right: 10px;
        font-size: 48px;
        color: $darkRed;
        text-align: right;
      }
    }
  }
  .list-move {
    transition: transform 1s;
  }
</style>




// WEBPACK FOOTER //
// RankingList.vue?2dc9cf19